import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M4 24v4h4L28 8l-4-4L4 24zm21-13l-4-4" fill="none" />
  </Icon>
);
